import React, { useMemo } from 'react';
import error from '../../animations/error.json';
import { sanitizeLottieName } from '../../utils/sanitize';
import { getInlineStyles } from '../../utils/styles';
import { TLottieAnimationViewProps } from './LoadingAnimationView';
import { recolorLottie } from './recolorLottie';
import { useLottieAnimation } from './useLottieAnimation';

export const ErrorAnimationView = ({ uid, animationsColor, margin }: TLottieAnimationViewProps) => {
    const sanitizedUid = sanitizeLottieName(uid ?? 'error');
    const animationData = useMemo(() => (animationsColor ? recolorLottie(error, animationsColor) : error), [animationsColor]);

    const { element } = useLottieAnimation({
        uid: sanitizedUid,
        animationData,
        loop: false,
        autoplay: true,
    });

    return <div data-test={uid} ref={element} style={getInlineStyles({ margin, height: '73px', width: '73px' })} />;
};
